module.exports = __webpack_public_path__ + "static/media/granny.f175154a.jpg";